{
  "version": 1,
  "asset_id": "1e39ade5-abd4-470f-a4b6-1322e31741e9",
  "project_id": "a3e359cb-5308-4f2a-8ac0-def799d4abdd",
  "url": "/__l5e/assets-v1/1e39ade5-abd4-470f-a4b6-1322e31741e9/entities-teaser.mp4",
  "r2_key": "a/v1/a3e359cb-5308-4f2a-8ac0-def799d4abdd/1e39ade5-abd4-470f-a4b6-1322e31741e9/entities-teaser.mp4",
  "original_filename": "entities-teaser.mp4",
  "size": 1781337,
  "content_type": "video/mp4",
  "created_at": "2026-10-14T00:46:01Z"
}
